import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse,HttpParams, HttpHeaders,HttpEvent,HttpRequest } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import { EnvService } from '../services/env.service';

const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})

export class KitchenStockConsumptionService {

  dataRow : any;

  constructor(private http: HttpClient,private env: EnvService) { }

   getAll():Observable <any> {
    return this.http.get<any>(`${this.env.apiUrl}/kitchen-stock-consumption`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }

    getReport(startDate:string, endDate:string):Observable <any> {
      let params = new HttpParams();
      params = params.append('startDate',String(startDate));
      params = params.append('endDate',String(endDate));

      return this.http.get<any>(`${this.env.apiUrl}/kitchen-stock-consumption/report`,{params,headers: new HttpHeaders({'Content-Type':'application/json'})})
      .pipe(catchError(this.handleError));
         
      }

    create(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/kitchen-stock-consumption`,  data)
        .pipe(catchError(this.handleError));
       
    }

 
    private handleError(errorResponse: HttpErrorResponse) { 
      return throwError(errorResponse || "Server Error");

      }


}
